import { Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';

const showLoadingDelay = 800;

const Loading: React.FC = () => {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    const timeoutId: NodeJS.Timeout | null = setTimeout(
      () => setShowLoading(true),
      showLoadingDelay
    );

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <Box
      sx={{
        opacity: showLoading ? 1 : 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        transition: 'opacity 1s ease-out',
      }}
    >
      <CircularProgress size={60} />
    </Box>
  );
};

export default Loading;
